export default {
    "getPreferencesOpt": "3bb86ee56c15ec1d80c1a585703f159467286179ccf41845ef7cebeec044d4e4",
    "updateNotificationPreferences": "cb70156ec91a7adb1da8f39a3b663ed74f6ae2ae5813d23d43e36094fc227b6b"
};
